import { createSelector } from 'reselect';
const userStateSelector = (state) => state.user;
export const userFeedStateSelector = createSelector(userStateSelector, (user) => user.feed);
export const userFeedSelector = createSelector(userFeedStateSelector, (feed) => feed.userFeed);
export const userFeedDataSelector = createSelector(userFeedSelector, (userFeed) => (userFeed ? userFeed.data : null));
const userFeedMetaSelector = createSelector(userFeedSelector, (userFeed) => (userFeed ? userFeed.meta : null));
export const userFeedNextSelector = createSelector(userFeedMetaSelector, (userFeedMeta) => (userFeedMeta ? userFeedMeta.next : null));
export const userFeedhasNextSelector = createSelector(userFeedMetaSelector, (userFeedMeta) => (userFeedMeta ? userFeedMeta.hasNext : null));
export const userFeedErrorSelector = createSelector(userFeedStateSelector, (feed) => feed.error);
export default {
    userFeedDataSelector,
    userFeedMetaSelector,
    userFeedNextSelector,
    userFeedhasNextSelector,
    userFeedErrorSelector,
};
